import { MULTITAB_SETPASO, MULTITAB_LOGOUT,MULTITAB_SETORIGEN, RESET_PORTAL_CONTEXT } from "../ActionTypes";

import multiTabInitialState from "../initialStates/multiTabInitialState";

const multiTab = (state, { payload, type }) => {
  switch (type) {
    case MULTITAB_SETPASO:
      return {
        ...state,
          multiTab: {
            ...state.multiTab,
            paso: payload,           
          },
      };
      case MULTITAB_SETORIGEN:
        return {
          ...state,
          multiTab: {
            ...state.multiTab,
            origen: payload,           
          },
        };
    case MULTITAB_LOGOUT:
      return multiTabInitialState;
    case RESET_PORTAL_CONTEXT:
      return multiTabInitialState;
    
    default:
      return state;
  }
};

export default multiTab;
